import classNames from 'classnames'
import { CommonButton } from 'CommonButton'
import PropTypes from 'prop-types'
import React from 'react'
import { countryIdToString } from 'utils/countryUtils'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

const displayTabs = (boxTitles, changeType, storeType) =>
  boxTitles.map(obj => (
    <Box key={obj.title} mb={1} mr={1}>
      <CommonButton
        className={classNames({ 'is-active': obj.type === storeType })}
        isUpperCase={false}
        variant={obj.type === storeType ? 'primary' : 'secondary'}
        onClick={event => changeType(event, obj.type)}
      >
        {obj.icon}
        {obj.title}
      </CommonButton>
    </Box>
  ))

const displaySingle = (boxTitle, subheader) => (
  <>
    {boxTitle}
    {subheader}
  </>
)

const BoxHeader = ({ boxTitles, changeType, children, country, isOpen, logo, showOpenIcon, storeType, subheader, toggleOpen }) => {
  if (!children && !boxTitles) {
    return null
  }

  return (
    <Box className="box-header cursor-pointer" onClick={toggleOpen}>
      <Box className={classNames('box-header_title', { 'is-company': !Array.isArray(boxTitles) })} display="flex">
        {logo && <div className={classNames('logo', `flag-${logo}`)} />}
        {Array.isArray(boxTitles) ? displayTabs(boxTitles, changeType, storeType) : displaySingle(boxTitles, subheader)}
        {children}
      </Box>
      <div className="box-header_icon">
        {country && <i className={classNames('flag', `flag-${countryIdToString(country)}`)} />}

        {showOpenIcon && (
          <IconButton>
            <i className={classNames('cursor-pointer icon open-icon', { reverse: isOpen })} />
          </IconButton>
        )}
      </div>
    </Box>
  )
}

BoxHeader.propTypes = {
  boxTitles: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.node,
        title: PropTypes.string,
        type: PropTypes.string,
      }),
    ),
  ]),
  changeType: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  country: PropTypes.number,
  isOpen: PropTypes.bool,
  logo: PropTypes.string,
  showOpenIcon: PropTypes.bool,
  storeType: PropTypes.string,
  subheader: PropTypes.node,
  toggleOpen: PropTypes.func,
}

export default BoxHeader
